import React, { useEffect } from 'react';
import styles from "../ContentBlocks.module.css";
import classnames from 'classnames';
import { ParrallaxContainer } from '../../ParrallaxBlock';
import { getAssetPathByHeight, useDeviceClassification } from 'utils';
import uuid from "react-uuid";
import $ from "jquery";
import classNames from 'classnames';
import { Background } from 'react-parallax';
import { TextEditor } from 'components/molecules/TextEditor';


const _FullWidthPromoImageTextBlock = ({ ...props }) => {
    const { isMobile, isTablet, isDesktop } = useDeviceClassification();
    useEffect(() => {
        isDesktop && $('.FullWidthImageTextBlock .postcontent *').css({ color: props.DescriptionTextColour.Value ? `${props.DescriptionTextColour.Value}` : '#353d30' });
    })

    // Dynamically choose best block image based on device width.
    const chooseBestBlockImage = () => {
        if (isMobile) {
            return { Src: props.BlockImageMobile?.Src || props.BlockImageTablet?.Src || props.BlockImageDesktop?.Src, Alt: props.BlockImageMobile?.Alt || props.BlockImageTablet?.Alt || props.BlockImageDesktop?.Alt }
        } else if (isTablet) {
            return { Src: props.BlockImageTablet?.Src || props.BlockImageDesktop?.Src || props.BlockImageDesktop?.Src, Alt: props.BlockImageTablet?.Alt || props.BlockImageDesktop?.Alt }
        } else {
            return { Src: props.BlockImageDesktop?.Src, Alt: props.BlockImageDesktop?.Alt }
        }
    };

    const { Src, Alt } = chooseBestBlockImage();

    return (
        <div className="slide-down FullWidthImageTextBlock">

            <ParrallaxContainer
                height={isDesktop ? '100vh' : '65vh'}
                className={`FullWidthImageTextBlock-${uuid()}`}
                type={'FullWidthImageTextBlock'}
            >
                <Background className="custom-bg">
                    <img src={getAssetPathByHeight(Src, Math.floor((window.innerHeight / 100) * (isDesktop ? 100 : 65)))} alt={Alt} />
                </Background>

                {isDesktop && <>
                    <div
                        className={classnames(styles.ImageBlock_TextWrapper)}
                    >
                        <div className={`contentWrapper ${props.DescriptionOverlayAlignment.Class}`}>
                            <TextEditor className={classNames("textBox", "ImageBlock", "postcontent", "animateonscroll", "c-block", { noPadding: !Boolean(props.DescriptionOverlayBackgroundColour?.Value) })}
                                style={{
                                    width: `calc((100% / 12 * ${props.DescriptionOverlayColumn}) + (${isDesktop ? 40 : 20}px / 12 * ${props.DescriptionOverlayColumn} - ${isDesktop ? 40 : 20}px))`,
                                    background: props.DescriptionOverlayBackgroundColour?.Value,
                                    color: props.DescriptionTextColour.Value ? `${props.DescriptionTextColour.Value}` : '#353d30'
                                }}
                                data={props.Description}
                            />
                        </div>
                    </div>
                </>}
            </ParrallaxContainer>
            {!isDesktop &&
                <div
                    className={classnames(styles.ImageBlock_TextWrapperMobile)}>
                    <TextEditor
                        className="textBox postcontent c-block animateonscroll"
                        data={props.Description}
                    />
                </div>
            }

        </div>);
};

export const FullWidthPromoImageTextBlock = React.memo(_FullWidthPromoImageTextBlock);
